import {
  imageResultSelectorFam,
  searchPageNoAtom,
  searchPageSizeAtom,
} from 'packages/omnitag/state';
import SkeletonImage from 'packages/lib/assets/skeleton-image.svg?react';
import { Link, useLocation } from 'react-router-dom';
import { mergeImageQueryURLParams } from 'packages/omnitag/results/zoomed-image-preview';
import styled from '@emotion/styled';
import { AnnotatedImage } from 'packages/omnitag/results/annotated-image';
import { FC } from 'react';
import { JobStatus } from 'packages/lib/api/logminer/contract/log-miner-types';
import { OmnitagResultItem } from 'packages/lib/api/omnitag/contract/omnitag-search';
import { useAtomValue } from 'jotai';

const MissingImage = styled.div`
  font-size: 0.65rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

interface ThumbnailImageAndLinkProps {
  result: OmnitagResultItem;
  jobStatus: JobStatus | null;
  className?: string;
}

export const ThumbnailImageAndLink: FC<
  React.PropsWithChildren<ThumbnailImageAndLinkProps>
> = ({ result, jobStatus, className }): JSX.Element | null => {
  const location = useLocation();
  const pageSize = useAtomValue(searchPageSizeAtom);
  const pageNo = useAtomValue(searchPageNoAtom);
  const imageSrc = useAtomValue(
    imageResultSelectorFam({
      logName: result.log_name,
      timestamp: result.timestamp,
      channel: result.channel,
    })
  );

  if (!imageSrc) {
    return (
      <MissingImage className="ant-skeleton-element">
        <SkeletonImage fill="gray" style={{ width: '64px' }} />
        {result.log_name} <br />
        {result.timestamp} <br />
        {result.channel} <br />
      </MissingImage>
    );
  }

  const link =
    location.pathname +
    '?' +
    mergeImageQueryURLParams(
      location,
      pageNo.toString(),
      pageSize.toString(),
      result
    );

  return (
    <Link to={link}>
      <AnnotatedImage
        zoom={0.2}
        style={jobStatus ? { filter: 'contrast(0.3)' } : {}}
        annotationsRed={result.bounding_box}
        annotationsBlue={result.track_box_2d}
        src={imageSrc}
        className={className}
      />
    </Link>
  );
};
